import { IServiceBrokerLevelPositionsDto, Nullable } from '@shared/api';
import { create } from 'zustand';

interface SecurityStore {
    securities: Nullable<IServiceBrokerLevelPositionsDto[]>;
    riaSecurities: Nullable<IServiceBrokerLevelPositionsDto[]>;
    setSecurities: (open: Nullable<IServiceBrokerLevelPositionsDto[]>) => void;
    setRiaSecurities: (open: Nullable<IServiceBrokerLevelPositionsDto[]>) => void;
}

// Create the Zustand store with types
const SecurityStore = create<SecurityStore>((set) => ({
    securities: [],
    riaSecurities: [],
    setSecurities: (open: Nullable<IServiceBrokerLevelPositionsDto[]>) => set({ securities: open }),
    setRiaSecurities: (open: Nullable<IServiceBrokerLevelPositionsDto[]>) => set({ riaSecurities: open }),
}));

export default SecurityStore;
